let url = process.env.VUE_APP_URL || '';

// 取消注释，启用全局变量读取
if (typeof window.meedu_app_url !== 'undefined' && window.meedu_app_url) {
  url = window.meedu_app_url;
}

console.log('API URL配置:', url); // 调试信息

export default {
  url: url
}